import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=6c77e4dc&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=6c77e4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77e4dc",
  null
  
)

export default component.exports